import { render, staticRenderFns } from "./SamAccordion.vue?vue&type=template&id=4613f7db&scoped=true&"
import script from "./SamAccordion.vue?vue&type=script&lang=js&"
export * from "./SamAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SamAccordion.vue?vue&type=style&index=0&id=4613f7db&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4613f7db",
  null
  
)

export default component.exports